import { ConditionCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/conditions';
import type { TriggerEvent } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/events';

import { UnpluggedIcon } from '@cobliteam/base-components';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import PinDropRoundedIcon from '@mui/icons-material/PinDropRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';

const getTriggerEventInfo = (triggerEvent: TriggerEvent) => {
  const { meta } = triggerEvent;

  switch (meta.conditionCategory) {
    // Geofence
    case ConditionCategory.GEOFENCE_IN:
      return {
        name: '- Gestão de locais',
        description: `entrou na área ${meta.geofence?.name}.`,
        icon: <PinDropRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'geofence',
      };
    case ConditionCategory.GEOFENCE_OUT:
      return {
        name: '- Gestão de locais',
        description: `saiu da área ${meta.geofence?.name}.`,
        icon: <PinDropRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'geofence',
      };
    case ConditionCategory.GEOFENCE_IN_OUT:
      return {
        name: '- Gestão de locais',
        description: `passou pela área ${meta.geofence?.name}.`,
        icon: <PinDropRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'geofence',
      };

    // Idle engine
    case ConditionCategory.IDLE_ENGINE_3_MINUTES:
      return {
        name: '- Motor ocioso',
        description: 'ficou parado por mais de 3 minutos.',
        icon: <AccessTimeRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'idle-engine',
      };
    case ConditionCategory.IDLE_ENGINE_5_MINUTES:
      return {
        name: '- Motor ocioso',
        description: 'ficou parado por mais de 5 minutos.',
        icon: <AccessTimeRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'idle-engine',
      };
    case ConditionCategory.IDLE_ENGINE_10_MINUTES:
      return {
        name: '- Motor ocioso',
        description: 'ficou parado por mais de 10 minutos.',
        icon: <AccessTimeRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'idle-engine',
      };
    case ConditionCategory.IDLE_ENGINE_15_MINUTES:
      return {
        name: '- Motor ocioso',
        description: 'ficou parado por mais de 15 minutos.',
        icon: <AccessTimeRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'idle-engine',
      };
    case ConditionCategory.IDLE_ENGINE_30_MINUTES:
      return {
        name: '- Motor ocioso',
        description: 'ficou parado por mais de 30 minutos.',
        icon: <AccessTimeRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'idle-engine',
      };

    // Device connection
    case ConditionCategory.DEVICE_CONNECTION_CONNECTED:
      return {
        name: '- Conexão do dispositivo',
        description: 'conectou o dispositivo no veículo.',
        icon: <UnpluggedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'device-connection',
      };
    case ConditionCategory.DEVICE_CONNECTION_DISCONNECTED:
      return {
        name: '- Conexão do dispositivo',
        description: 'desconectou o dispositivo do veículo.',
        icon: <UnpluggedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'device-connection',
      };
    case ConditionCategory.DEVICE_CONNECTION_CONNECTED_DISCONNECTED:
      return {
        name: '- Conexão do dispositivo',
        description: 'conectou e desconectou o dispositivo do veículo.',
        icon: <UnpluggedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'device-connection',
      };

    // Vehicle speed limit
    case ConditionCategory.VEHICLE_SPEED_LIMIT_1_MINUTE:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade por mais de 1 minuto.',
        icon: <BoltRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };
    case ConditionCategory.VEHICLE_SPEED_LIMIT_5_MINUTES:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade por mais de 5 minutos.',
        icon: <BoltRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };
    case ConditionCategory.VEHICLE_SPEED_LIMIT_10_MINUTES:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade por mais de 10 minutos.',
        icon: <BoltRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };

    // Road speed limit
    case ConditionCategory.ROAD_SPEED_LIMIT_1_MINUTE:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade da via por mais de 1 minuto.',
        icon: <SpeedRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };
    case ConditionCategory.ROAD_SPEED_LIMIT_5_MINUTES:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade da via por mais de 5 minutos.',
        icon: <SpeedRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };
    case ConditionCategory.ROAD_SPEED_LIMIT_10_MINUTES:
      return {
        name: '- Limite de velocidade',
        description: 'excedeu o limite de velocidade da via por mais de 10 minutos.',
        icon: <SpeedRoundedIcon className='size-4 bg-gray-lightest rounded-full p-1 box-content' />,
        type: 'speed',
      };

    default:
      return {
        name: '',
        description: '',
        icon: null,
        type: 'geofence',
      };
  }
};

export { getTriggerEventInfo };
